<template>
  <div class="w-full h-36 py-4 text-center bg-blue-100">
    <nav class="flex items-center justify-center w-full h-16 text-sm">
      <ul class="flex items-center">
        <li>
          <router-link to="/" exact>Home</router-link>
        </li>
        <li>
          <router-link to="/about">About</router-link>
        </li>
        <li>
          <router-link to="/stations">Station Search</router-link>
        </li>
        <li class="flex">
          <a href="#" class="h-12 w-12">
            <img src="/images/social/instagram.png" />
          </a>
          <a href="#" class="ml-6 h-12 w-12">
            <img src="/images/social/facebook.png" />
          </a>
        </li>
        <li>
          <router-link to="/cops">Rate A Cop</router-link>
        </li>
        <li>
          <router-link to="/forum">Local Forum</router-link>
        </li>
        <li>
          <router-link to="/profile" v-if="isAuthenticated">Profile</router-link>
          <router-link to="/login" v-else>Login</router-link>
        </li>
      </ul>
    </nav>
    <p
      class="pt-4"
    >&copy; {{ new Date().getFullYear() }} Good Cop Bad Cop. Designed by Divine Digital Agency</p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("auth", ["isAuthenticated"])
  },
};
</script>

<style lang="scss" scoped>
ul > li {
  float: left;
  padding: 0 48px;

  a:hover,
  a.router-link-active {
    color: #4db1fa;
  }
}
</style>
